import script from "./RejectRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./RejectRequestForm.vue?vue&type=style&index=0&id=24f63a4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f63a4c"]])

export default __exports__